module.exports = __webpack_public_path__ + "static/image4-f5fed2d29f2e4b77b8d471d1daa7398f.jpg";